import React from 'react'

export const Pago = () => {
  return (
  
        <form >
        
          <div className='flexpago'>
          
            <p className='tarp'> Datos de pago</p>
             
                <label> Número de tarjeta </label>
                <input type='text' name='name' placeholder='Número de la tarjeta' />
          
             
                <label> Nombre del titular </label>
                <input type='text' name='titular' placeholder='Nombre del titular' />
             
             
                <label> Fecha de vencimiento </label>
                <input type='text' name='caducidad' placeholder='Fecha de vencimiento' />
            
             
                <label> Código de seguridad </label>
                <input type='text' name='codigoseguridad' placeholder='Código de seguridad' />

                <p> Versión Demo de sitio web, no cargue sus datos.</p>
               
          </div>
        </form>
        
   
  )
}
